import React from "react";
import { Circle, type CenterProps, useTheme } from '@/index'
import { keyframes } from "@/utils/keyframes";
import { transparentize } from "polished";


const animation = (color: string, size: string) => 
  keyframes({
    '0%': {
      transform: 'scale(0.95)',
      boxShadow: `0 0 0 0 ${transparentize(0.2, color)}`
    },
    
    '70%': {
      transform: 'scale(1)',
      boxShadow: `0 0 0 ${size} transparent`
    },
    
    '100%': {
      transform: 'scale(0.95)',
      boxShadow: `0 0 0 0 transparent`
    }
  })


interface ActiveStateProps extends CenterProps {}

const Component = React.forwardRef((props: ActiveStateProps, ref: React.Ref<any>) => {
  const theme = useTheme()

  const primaryColor = theme.colors?.scene?.primary?.normal
  const size = theme.sizes?.['xs']

  return (
    <Circle
      ref={ref}
      position='absolute'
      top='0px'
      left='0px'
      width='100%'
      height='100%'
      animation={`${animation(primaryColor, size)} 2s infinite`}
      {...props}
    />
  )
})


export {
  Component as ActiveState,
  type ActiveStateProps,
}